"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_OWNERSHIP = void 0;
const roles_1 = require("./roles");
exports.ROUTE_OWNERSHIP = [
    { prefix: '/static/legacy', owner: 'legacy-admin', area: 'assets' },
    { prefix: '/vendors', owner: 'legacy-admin', area: roles_1.AREAS.VENDORS },
    { prefix: '/promo-codes', owner: 'legacy-admin', area: roles_1.AREAS.PROMO_CODES },
    {
        prefix: '/rules',
        owner: 'legacy-admin',
        plannedOwner: 'admin-modern',
        area: roles_1.AREAS.RULES,
    },
    { prefix: '/cms', owner: 'legacy-admin', area: roles_1.AREAS.CMS },
    { prefix: '/access-denied', owner: 'legacy-admin', area: 'platform' },
    { prefix: '/authorize', owner: 'legacy-admin', area: 'platform' },
    { prefix: '/', owner: 'legacy-admin', area: 'platform' },
];
